import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="navigation"
export default class extends Controller {
 
  toggle() {
    // Close all other details elements
    this.element.closest(".navigation").querySelectorAll("details").forEach(detail => {
      if (detail !== this.element) {
        detail.removeAttribute("open");
      }
    });
  }

}
